import CheckoutInfoErrorData from './CheckoutInfoErrorData';

export default function isCheckoutInfoErrorData(value: any): value is CheckoutInfoErrorData {
  return value && 'type' in value && 'details' in value;
}
